// components/DataTable/utils.js

/**
 * @param {Object} row
 * @param {string|function(Object): (string|number)} rowKey
 * @param {number} index
 * @returns {string|number}
 */
export function getRowKey(row, rowKey, index) {
  if (typeof rowKey === "function") {
    return rowKey(row);
  }

  if (typeof rowKey === "string") {
    return row[rowKey];
  }

  return index;
}

/**
 * @param {*} value
 * @param {string} locale
 * @returns {string}
 */
export function formatNumber(value, locale) {
  if (value === null || value === undefined || value === "") {
    return "";
  }

  const number = Number(value);

  if (!Number.isFinite(number)) {
    return "";
  }

  return new Intl.NumberFormat(locale).format(number);
}

/**
 * @param {*} value
 * @param {number} maxLength
 * @returns {string}
 */
export function truncateText(value, maxLength) {
  if (value === null || value === undefined) {
    return "";
  }

  const text = String(value);

  if (!maxLength || text.length <= maxLength) {
    return text;
  }

  return text.substring(0, maxLength) + "...";
}

/**
 * @param {Object} row
 * @param {Object} column
 * @returns {*}
 */
export function getCellValue(row, column) {
  return row ? row[column.field] : undefined;
}

/**
 * @param {Object} row
 * @param {Object} column
 * @param {*} value
 * @returns {Object}
 */
export function setCellValue(row, column, value) {
  return {
    ...row,
    [column.field]: value
  };
}

/**
 * @param {Array<Object>} dataSource
 * @param {Object} column
 * @param {*} value
 * @returns {Object|null}
 */
export function findDropdownItem(dataSource, column, value) {
  if (!Array.isArray(dataSource)) {
    return null;
  }

  return (
    dataSource.find(item => {
      if (!item) {
        return false;
      }

      return String(item[column.valueField]) === String(value);
    }) || null
  );
}